export default "__VITE_PUBLIC_ASSET__c76c447f__"